<template>
    <DesktopStickyBanner
        v-if="showDesktopSticky"
        :key="route.path"
    />
    <MobileStickyBanner
        v-if="showMobileSticky"
        :key="route.path"
        :placement="mobilePlacement"
    />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { ROUTE_NAMES } from '@/router/constants'
import { useAdsStore } from '@/store/ads-store/index.js'
import { useAppStore } from '@/store/app-store'
import { useGoogleAuthStore } from '@/store/google-auth-store'
import { useLayoutStore } from '@/store/layout-store'
import { usePWAInstallStore } from '@/store/pwa-install/store'

import DesktopStickyBanner from './DesktopStickyBanner.vue'
import MobileStickyBanner from './MobileStickyBanner.vue'

const route = useRoute()

const pwaInstallStore = usePWAInstallStore()
const { promptDisplayed } = storeToRefs(useGoogleAuthStore())
const { fullScreen } = storeToRefs(useLayoutStore())
const { platform, isAppEnv } = storeToRefs(useAppStore())
const { nativeBannersEnabled } = storeToRefs(useAdsStore())

const showDesktopSticky = computed(() => platform.value === 'desktop' && route.meta.showDesktopStickyBanner)

const mobilePlacement = computed(() =>
    route.name === ROUTE_NAMES.GAME_PAGE ? 'sticky_mobile' : 'sticky_mobile_non_game_page',
)

const showMobileSticky = computed(
    () =>
        platform.value !== 'desktop' &&
        (!isAppEnv.value || nativeBannersEnabled.value) &&
        route.meta.showMobileStickyBanner &&
        !fullScreen.value &&
        !pwaInstallStore.isDisplaying &&
        !promptDisplayed.value,
)
</script>
